/**
 * Sets up intersection observer for infinite scroll
 */
export const setupIntersectionObserver = (
  triggerElement: HTMLTableRowElement | null,
  hasMoreData: boolean,
  loading: boolean,
  loadingMore: boolean,
  loadMore: () => void
): (() => void) | undefined => {
  if (!triggerElement || !hasMoreData || loading || loadingMore) {
    return undefined;
  }

  const observer = new IntersectionObserver(
    entries => {
      const [entry] = entries;
      if (entry.isIntersecting) {
        loadMore();
      }
    },
    {
      threshold: 0.1,
      rootMargin: '100px',
    }
  );

  observer.observe(triggerElement);

  return () => {
    observer.unobserve(triggerElement);
  };
};
